import LocalizedStrings from 'react-localization';

export const getTranslations = (language) => {

  let strings =
  {
    en: {
      error: "An error has occurred",
      loading: "Loading",
      signup: "Application",
      errorFileTooLarge:"File is too large. Limit is",
      sending: "Sending",
      send: "Send",
      applyToTender: "Apply to the tender",
      noTenders: "No tenders available",
      listOfTenders: "Tenders list",
      applicationForm: "Application form",
      fillAllTheFields: "Fill all the fields",
      successDialogTitle: "Application was successfully submitted. Thank you very much for your trust.",
      successDialogMessage: "",
      close:"OK",
      submitButtonText:"Submit application",
      showMore: "Show more",
      validTo: "Valid to"
    },
    sl: {
      error: "Prišlo je do napake",
      loading: "Nalaganje v teku",
      signup: "Prijava na razpis",
      errorFileTooLarge:"Datoteka je prevelika. Največja dovoljena velikost je",
      sending: "Pošiljam",
      send: "Pošlji",
      applyToTender: "Prijavi se",
      noTenders: "Na voljo ni nobenega razpisa",
      listOfTenders: "Vsa prosta delovna mesta",
      applicationForm: "Obrazec za prijavo",
      fillAllTheFields: "Prosimo, izpolnite vsa obvezna polja.",
      successDialogTitle: "Prijava na razpis je bila uspešno oddana. Najlepša hvala za vaše zaupanje.",
      successDialogMessage: "",
      close:"OK",
      submitButtonText:"Oddaj prijavo",
      showMore: "Prikaži več",
      validTo: "Datum poteka objave"
    },
    sr: {
      error: "Greška",
      loading: "Učitavanje u toku",
      signup: "Prijava na konkurs",
      errorFileTooLarge:"Fajl je prevelik. Maksimalna veličina je",
      sending: "Slanje",
      send: "Šalji",
      applyToTender: "Prijava na konkurs",
      noTenders: "Nema konkursev",
      attachments: "Prilozi",
      listOfTenders: "Lista konkursev",
      applicationForm:"Prijavni formular",
      fillAllTheFields: "Prosimo, izpolnite vsa obvezna polja.",
      successDialogTitle:"Prijava na razpis je bila uspešno oddana. Najlepša hvala za vaše zaupanje.",
      successDialogMessage:"Prijava na razpis je bila uspešno oddana. Najlepša hvala za vaše zaupanje.",
      close:"OK",
      submitButtonText:"Oddaj prijavo",
      showMore: "Prikaži više podataka",
      validTo: "Važi do"
    }
  };
  const localizedStrings = new LocalizedStrings(strings);
  localizedStrings.setLanguage(language)
  return localizedStrings;
}

export default { getTranslations };